import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { api } from '../api/client.js';

const KEY = 'ominia.selectedTenant';

const TenantContext = createContext({
  tenantId: null,
  setTenantId: (_id) => {},
});

export function TenantProvider({ children }) {
  const [tenantId, setTenantIdState] = useState(() => {
    const raw = window.localStorage.getItem(KEY);
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : null;
  });

  const setTenantId = useCallback((id) => {
    const n = id ? Number(id) : null;
    setTenantIdState(Number.isFinite(n) && n > 0 ? n : null);
    if (Number.isFinite(n) && n > 0) window.localStorage.setItem(KEY, String(n));
    else window.localStorage.removeItem(KEY);
  }, []);

  /**
   * O id no localStorage pode ficar obsoleto (outra conta, empresa apagada, ou era de super_admin).
   * A API só aceita tenant cujo user_id coincide com o JWT — senão 403 "sem permissão nesta empresa".
   */
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const data = await api('/tenants');
        if (!alive) return;
        const allowed = new Set((data.tenants || []).map((t) => Number(t.id)));
        setTenantIdState((cur) => {
          const id = cur != null && Number(cur) > 0 ? Number(cur) : null;
          if (id != null && !allowed.has(id)) {
            window.localStorage.removeItem(KEY);
            return null;
          }
          return cur;
        });
      } catch {
        /* sessão inválida ou rede — não forçar limpeza */
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  const value = useMemo(() => ({ tenantId, setTenantId }), [tenantId, setTenantId]);

  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
}

export function useTenant() {
  return useContext(TenantContext);
}
